import { useContext, useEffect, useState } from 'react'

// New imports
import axios from 'axios'
import axio from 'axios'
import Modal from 'react-modal'
import { EditIntent, IntentDetail, NewIntent } from '../components/intents'

import EditProjectModal from '../components/EditProjectModal'
import '../styles/answerCRUD.scss'
import '../styles/answers.scss'
import { customModal } from '../styles/customModal'
import TitleBar from "../components/TitleBar";

import { viewShield } from '../lib/security/viewShield.js'
import { projectContext, loadingContext, unfolder, openAlert, useTranslate } from '../lib'
import { urlValue } from '../lib'

import SideBar from '../components/SideBar'

import '../styles/project.scss'
import '../styles/general.scss'
import { useForm } from "react-hook-form";
import { Alerts } from '../components/common/Alerts'
import Button from '../components/provider/button/button.jsx'
import H3 from '../components/provider/h3/H3.jsx'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

export default function Project() {

  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [isModalOpen, setIsModalOpen] = useState({
    drop: false,
    edit: false,
  })
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [refresh, setRefresh] = useState(0);
  const [imgSelected, setImgSelected] = useState(null);

  const closeModal = () => {
    setIsModalOpen({ drop: false, edit: false })
  }

  const openModal = () => {
    setIsModalOpen({ drop: false, edit: true })
  }

  const [loading, setLoading] = useContext(loadingContext)
  const [error, setError] = useState({ name: "" })
  const [projectName, setProjectName] = useState();
  const [description, setDescription] = useState();
  const [welcomeMsg, setWelcomeMsg] = useState();
  const { t } = useTranslate();
  const [imageName, setImageName] = useState(t('menu.uploadProjectImage'));
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  const getProject = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/${selectedProject.id}`,
      headers: {
        user: id,
        'access-token': token,
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {

        setSelectedProject(response.data)
        setProjectName(response.data.name)

        // Seguridad XSS
        //const safeWelcomeMsg = viewShield(response.data.welcome_msg);
        const safeWelcomeMsg = response.data.welcome_msg;
        const welcomeInput = document.getElementById('welcome_msg');
        if (welcomeInput) {
          welcomeInput.innerHTML = safeWelcomeMsg;
        }

        setLoading(false)
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }

  useEffect(() => {
    getProject()
  }, [])

  const saveProject = async (e) => {
    e.preventDefault();
    setLoading(true);

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    const name = document.querySelector("#name-project").value;
    let convertedFile = ""

    if (image) {
      convertedFile = await convertToBase64(image)
    }

    const exp = /^[A-Za-z0-9-,._'\s]+$/g;
    if (!exp.test(name)) {
      ok = false;

      setError({ ...error, name: t('errors.nameInvalid') })
    }
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    if (ok) {

      selectedProject.metadata.description = document.getElementById('description').value
      const dataSend = {
        id: selectedProject.id,
        name: name,
        description: selectedProject.description,
        welcome_msg: document.getElementById('welcome_msg').value,
        metadata: selectedProject.metadata,
        image: { "imageName": convertedFile ? imageName : selectedProject.image, "url": "" } || null,
        imageFile: convertedFile || null,
        time_hold_amount: selectedProject.AmountTimeHold,
        time_hold_seconds: selectedProject.TimeSecondHold,
        bot_sentiment: selectedProject.bot_sentiment,
        campaing: selectedProject.campaing_id,
        category: selectedProject.category,
        channel: selectedProject.channel,
        model_sentiment: selectedProject.model_sentiment,
        nlp: selectedProject.nlp,
        nlp_url: selectedProject.nlp_url,
        outbound_call: selectedProject.outbound_call,
        random_voice: selectedProject.random_voice,
        sub_campaing: selectedProject.sub_campaing_id,
        transcription: selectedProject.transcription,
        url_tp_simulation: selectedProject.url_tp_simulation,
        use_hold: selectedProject.useHold,
        use_default_sentiment: selectedProject.use_default_sentiment,
        voice: selectedProject.voice_id
      }

      axios({
        method: 'post',
        url: `${urlValue}/studio/project/update`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.projectSaved'), visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          setSelectedProject({
            ...selectedProject, name: name
          })

          setRefresh(refresh + 1)
          getProject();
          closeModal();
          setLoading(false)
          setImageName(t('menu.uploadProjectImage'));
        })
        .catch(function (error) {
          setLoading(false)
          console.error("error ", error)
        })
    }

  }

  const convertToBase64 = (file) => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      }
    })
  }

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImagePreview(URL.createObjectURL(event.target.files[0]));
    }
  }

  const changeImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImgSelected(URL.createObjectURL(e.target.files[0]));
      setImage({ name: e.target.files[0].name, file: e.target.files[0] })
    }
  }
  return (
    <div>
      <div className="container-project general-container" id="container-proj">
        <SideBar project={selectedProject} active={'Project'} />
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <h1 className="ml-2">{t('common.project')}</h1>
          <form onSubmit={saveProject} className="body d-flex flex-column pl-2 pt-3">

            <div className="description">
              <div>
                <input id="name-project" defaultValue={projectName} {...register('name', { required: true })}
                  className="pl-2" type="text"
                  style={{
                    borderRadius: 8, height: 40, backgroundColor: 'white', width: 'auto', border: '1px solid #A1A1A0',
                    textTransform: 'capitalize', fontSize: 16, color: '#0B5FA3', fontWeight: "bold"
                  }}
                />

                {/* <div className='img-content'>
                  
                   {imgSelected ?  <img  src={imgSelected}  alt='' className='img-preview' /> : 
                   selectedProject?.image ? <img  src={selectedProject.image}  alt='' className='img-preview' />: null}
                 <div className='img-file-div'>
                    <div className='upload-img-div'>
                      <p className='name-img'>{selectedProject.imageName}</p>
                      <div className='content-upload'> 
                        <input onChange={changeImage} type='file' className='input-file' />
                        <button className='btn-upload'>Upload</button>
                      </div>
                    </div>
                 </div>
              </div> */}
              </div>

              <div className="inputs" style={{ marginTop: 20 }} id="image">
                <div className="input settings-container d-flex flex-row">
                  <img src={selectedProject.image} id="image_uploaded" width="200" alt="" style={{ display: imagePreview ? 'none' : 'block' }} />
                  <img src={imagePreview} id="image_preview" style={{ display: imagePreview ? 'block' : 'none' }} width="200" alt="" />
                  <div className="d-flex flex-column justify-end ml-2" style={{ minWidth: 100 }}>
                    <div className="mb-3" style={{ maxWidth: 150, fontSize: 13 }}>{selectedProject.imageName}</div>
                    <label className="custom-file mt-4" style={{ width: '100%' }}>
                      <input
                        onChange={(e) => {
                          const file = e.target.files[0];

                          if (file && file.type.startsWith('image/')) {
                            setImage(e.target.files[0]);
                            setImageName(e.target.files[0].name);
                            onImageChange(e);
                          } else {
                            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.validImage'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
                            e.target.value = null; // limpia el input
                          }
                        }}
                        type="file"
                        accept="image/png, .jpeg, .jpg"
                      />
                      {imageName}
                    </label>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-row align-center mt-5'>
                <H3 text={`${t('common.description')}:`} style={{ fontWeight: 'bold', marginTop: 0 }} />
                <img id="description-project" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-2" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#description-project"
                  html={t('menu.descriptionTooltip')} place="top" />
              </div>
              <textarea id="description" {...register('description', { required: true })}
                className="p-2" style={{
                  border: '1px solid #A1A1A0', borderRadius: 8, backgroundColor: 'white',
                  fontSize: 14, height: 100, marginTop: 10
                }}>
                {typeof selectedProject?.metadata?.description !== "string" ?
                  // selectedProject?.metadata?.description?.map((data, index) => (
                  //   <p key={index}>{data}</p>
                  // ))
                  ""
                  : selectedProject?.metadata?.description}
              </textarea>

            </div>
            <div className="data">
              <div className='d-flex flex-row align-center'>
                <h3 style={{ marginTop: 0, color: '#474746', fontWeight: 'bold' }}>{t('menu.genai.outboundCallMessage')}:</h3>
                <img id="outbound-call-message" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-2" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#outbound-call-message"
                  html={t('menu.genai.outboundCallMessageTooltip')} place="top" />
              </div>

              <textarea id="welcome_msg" {...register('welcome_msg', { required: false })}
                className="p-3" style={{
                  border: '1px solid #A1A1A0', borderRadius: 8, backgroundColor: 'white',
                  fontSize: 14, height: 60, marginTop: 10
                }}>

              </textarea>

              <p style={{ color: '#575756' }}>{selectedProject?.metadata?.availability}</p>
              <p style={{ color: '#575756' }}>{t('common.testingEndpoint')}</p>
              <p style={{ color: '#575756' }}>{selectedProject?.metadata?.testing_endpoint}</p>
              <p style={{ color: '#575756' }}>{t('common.language')}</p>
              <p style={{ color: '#575756' }}>{selectedProject?.metadata?.language}</p>
            </div>
            <div className='cont-buttons mt-5 w-100'>
              <div className="buttons d-flex flex-row justify-end pr-3">
                <Button
                  type="submit"
                  label={t('common.save')}
                  style={{ fontSize: 16, padding: '5px 30px' }}
                  className='buttonG ml-3'
                />
                {/*
                <button className="create btn-primary" type="submit" style={{backgroundColor: "#0087FF"}}>
                  Save
                </button>
                */}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/*<Modal isOpen={isModalOpen.drop} onClose={handleClose} style={customModal} ariaHideApp={false}>*/}
      {/*  <div id="container-modal">*/}
      {/*    <img src="/icons/alert.png" />*/}
      {/*    <h1>You are about to delete a project.</h1>*/}
      {/*    <h1>{t('menu.deleteConfirmQuestion')}</h1>*/}
      {/*    <div className="buttons-modal">*/}
      {/*      <button*/}
      {/*        onClick={handleClose}*/}
      {/*        className="cancel"*/}
      {/*      >*/}
      {/*        Cancel*/}
      {/*      </button>*/}
      {/*      <button onClick={deleteProject} className="accept">*/}
      {/*        Yes*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</Modal>*/}

      {/*<EditProjectModal*/}
      {/*  isModalOpen={isModalOpen.edit}*/}
      {/*  closeModal={closeModal}*/}
      {/*  update={() => { getProject() }}*/}
      {/*  refresh={refresh}*/}
      {/*  setRefresh={setRefresh}*/}
      {/*/>*/}
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
    </div>
  )
}
